import NiceModal from '@ebay/nice-modal-react';

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';
import Maps from 'components/maps/Maps';

import { STORAGE_PUBLIC } from 'services/consts';

import * as S from './TrackingInformations.styled';

const OrderLocationModal = NiceModal.create(({ orderID, orderLocationData }) => {
	const { t } = useTranslation();
	const [map, setMap] = useState(null);

	useEffect(() => {
		if (map && orderLocationData?.lat && orderLocationData?.lng) {
			const maps = window?.google?.maps;
			if (!maps) return;

			(async () => {
				const { AdvancedMarkerElement } = await maps.importLibrary('marker');
				const markerImage = document.createElement('img');
				markerImage.src = `${STORAGE_PUBLIC}/mapview-icons/order2.svg`;
				markerImage.style.width = '40px';

				const marker = new AdvancedMarkerElement({
					position: { lat: parseFloat(orderLocationData.lat), lng: parseFloat(orderLocationData.lng) },
					content: markerImage,
					zIndex: 0
				});
				marker.setMap(map);
			})();
		}
	}, [orderLocationData, map]);

	return (
		<Modal maxWidth="large" fullwidth className="modal-currentOrderLocation">
			<ModalTitle>
				<Typography variant="p1">
					{t('currentOrderLocation')} (<strong>{orderID}</strong>)
				</Typography>
			</ModalTitle>

			<ModalContent>
				<S.CurrentOrderLocationWrapper>
					<Maps
						setMap={setMap}
						customMapSettings={{
							lat: orderLocationData?.lat,
							lng: orderLocationData?.lng,
							zoom: 11
						}}
					/>
				</S.CurrentOrderLocationWrapper>
			</ModalContent>
		</Modal>
	);
});

export default OrderLocationModal;
